/**
 * @todo Удалить директорию полностью, если эксперимент не будет  удачным
 * @description Данный функционал появился в задаче CD-138414, будет удалён в задаче CD-138473
 */
import { getGlobalEventsLogs } from '@cian/events-log';
import * as React from 'react';

import { ContractTemplateBlockView } from '../../components/ContractTemplateBlockView/ContractTemplateBlockView';
import { useTrackContractTemplateBlock } from './internal/hooks/useTrackContractTemplateBlock';
import { IContractTemplateBlockContainerProps } from './types';

export const ContractTemplateBlockContainer: React.VFC<IContractTemplateBlockContainerProps> = props => {
  const { isUserAuthenticated, isMiniature } = props;

  const trackContractTemplateBlockEvents = useTrackContractTemplateBlock();

  const handleClick = React.useCallback(() => {
    if (!isUserAuthenticated) {
      const globalLog = getGlobalEventsLogs();

      globalLog.produce('user', {
        type: 'authenticate',
        value: { autoRefresh: true },
      });

      trackContractTemplateBlockEvents('Click_auth_pact_trap');

      return;
    }

    trackContractTemplateBlockEvents('Click_download_pact');
  }, [isUserAuthenticated, trackContractTemplateBlockEvents]);

  return (
    <ContractTemplateBlockView
      isUserAuthenticated={isUserAuthenticated}
      isMiniature={isMiniature}
      onClick={handleClick}
    />
  );
};

ContractTemplateBlockContainer.displayName = 'ContractTemplateBlockContainer';
